<ng-container *transloco="let t; read: 'configuration-query-topics-component'">
  <app-configuration-item-editor
    [configuration]="configuration()"
    [configurationLayers]="configurationLayers()"
    [itemTypeTitle]="itemType"
    searchPlaceholder="{{ t('placeholder') }}"
    syntaxHelpLink="https://spotlight-docs.lexalytics.com/docs/query-operators"
    [loadItemsApi]="loadItems"
    [createItemApi]="createItem"
    [saveItemApi]="saveItem"
    [deleteItemApi]="deleteItem"
    [deleteAllItemsApi]="deleteAllItems"
    [evaluateItemApi]="evaluateItem"
    [evaluateDatasetApi]="evaluateDataset"
    [getEvaluationConfigApi]="getEvaluationConfig"
    [getHighlightTextString]="getHighlightText"
    [getEvaluationItemHighlightValue]="getItemHighlightValue"
    [getEvaluationItemByClonedFrom]="getItemByClonedFrom"
    [deleteEvaluationConfigApi]="deleteEvaluationConfig"
    [itemsEditable]="editable"
    [selectedItemId]="selectedItemId"
    [selectedItemName]="selectedItemName"
    [editorTemplate]="editorData"
    [testingEnabled]="canTestItem()"
    [taxonomyItemUsage]="taxonomyItemUsage?.query_topics"
    fragment="queries"
    [hasOptionsPopout]="true"
    (selectedItemChange)="onItemEditing($event)"
    (itemsLoaded)="onItemsLoaded($event)"
    (saving)="onItemSaving($event)"
    (itemsDeleted)="onItemsDeleted($event)"
    (allItemsDeleted)="onAllItemsDeleted($event)"
    (itemAdded)="onItemAdded($event)"
    (itemUpdated)="onItemUpdated($event)"
  ></app-configuration-item-editor>

  <ng-template #editorData let-item>
    <div class="configuration-query-topics__editor-toolbar">
      <div class="configuration-query-topics__editor-toolbar-row">
        <div class="configuration-query-topics__visibility-editor-slider">
          <xi-toggle-switch
            color="CX"
            [isToggled]="item.hidden"
            [disabled]="!!isSaving || !canEditItem()"
            (onToggle)="onHiddenChanged($event.detail.isToggled, item)"
            label="{{ t('is-hidden') }}"
            [leftText]="t('off')"
            [rightText]="t('on')"
          ></xi-toggle-switch>
        </div>

        <div class="configuration-query-topics__apply-to-sections-textbox-wrapper">
          <div class="configuration-query-topics__apply-to-sections-label kxi-xi-label">
            {{ t('apply-to-sections') }}
          </div>
          <xi-input-field
            id="configuration-query-topics__apply-to-sections"
            visualState="condensed"
            [value]="originalApplyToSections ?? ''"
            (onValueChange)="onApplyToSectionsChanged($event.detail.value, item)"
          ></xi-input-field>
        </div>
      </div>

      <div class="configuration-query-topics__purpose-text-wrapper">
        <cdk-accordion>
          <cdk-accordion-item
            #queryTopicPurposeAccordionItem="cdkAccordionItem"
            [expanded]="item.properties?.[LONG_PURPOSE_PROPERTY_NAME]"
          >
            <div class="configuration-query-topics__purpose-text-header">
              <strong
                class="configuration-query-topics__purpose-text-header-label"
                (click)="queryTopicPurposeAccordionItem.toggle()"
              >
                {{ t('description') }}
              </strong>

              <div class="configuration-query-topics__purpose-text-header-actions">
                @if (canEditItem()) {
                  @if (hasPurposeGenerationPermission) {
                    <xi-icon-button
                      icon="edit"
                      color="CX"
                      [disabled]="!!isSaving"
                      [matMenuTriggerFor]="editPurposeTextMenuTrigger"
                    ></xi-icon-button>
                  } @else {
                    <xi-icon-button
                      icon="edit"
                      color="CX"
                      [disabled]="!!isSaving"
                      (click)="onEditQueryTopicPurpose()"
                    ></xi-icon-button>
                  }
                  <mat-menu #editPurposeTextMenuTrigger class="menu-with-xi-icons">
                    <button
                      mat-menu-item
                      (click)="onEditQueryTopicPurpose()"
                      class="configuration-query-topics__edit-purpose-button"
                    >
                      <xi-icon-button icon="edit" color="CX"></xi-icon-button>
                      <span>{{ t('edit-description') }}</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="onGenerateQueryTopicPurpose()"
                      class="configuration-query-topics__edit-purpose-button"
                    >
                      <xi-icon-button icon="star" color="CX"></xi-icon-button>
                      <span>{{ t('generate-description') }}</span>
                    </button>
                  </mat-menu>
                }

                <xi-icon-button
                  [icon]="
                    queryTopicPurposeAccordionItem.expanded
                      ? 'single_arrow_up'
                      : 'single_arrow_down'
                  "
                  (onClick)="queryTopicPurposeAccordionItem.toggle()"
                ></xi-icon-button>
              </div>
            </div>
            <div
              class="configuration-query-topics__purpose-text-accordion"
              [style.display]="queryTopicPurposeAccordionItem.expanded ? '' : 'none'"
            >
              <div>{{ item.properties?.[LONG_PURPOSE_PROPERTY_NAME] }}</div>
            </div>
          </cdk-accordion-item>
        </cdk-accordion>
      </div>
    </div>
  </ng-template>
</ng-container>
